import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "../../primitives/Button";
import { AuthLayout } from "./AuthLayout";
export function ResetPasswordSuccess() {
    const navigate = useNavigate();
    return (_jsxs(AuthLayout, { centred: true, children: [_jsx("div", { className: "flex justify-center mb-6", children: _jsx(CheckCircle, { className: "w-14 h-14 text-duvi-success" }) }), _jsx("h1", { className: "text-duvi-text-primary mb-3", style: {
                    fontSize: "var(--text-xl)",
                    fontWeight: "var(--font-weight-semibold)",
                    lineHeight: "var(--line-height-heading)",
                }, children: "Password updated" }), _jsx("p", { className: "text-duvi-text-secondary mb-8", style: {
                    fontSize: "var(--text-sm)",
                    lineHeight: "var(--line-height-body)",
                }, children: "You can now sign in with your new password." }), _jsx(Button, { variant: "primary", className: "w-full", onClick: () => navigate("/auth/password"), children: "Sign in" })] }));
}
//# sourceMappingURL=ResetPasswordSuccess.js.map